import "./index.css";
import App from "./App";
import * as React from "react";
import * as ReactDOM from "react-dom/client";
import { LicenseInfo } from '@mui/x-license';

/* global document */

LicenseInfo.setLicenseKey(process.env.MUI_LICENSE);

const title = "Peerception";

const container = document.getElementById("container");
const root = ReactDOM.createRoot(container!);

root.render(
  <div className="h-screen bg-white">
    <App title={title} render_first_page={true} />
  </div>
);
